// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/css-loader/index.js??ref--10-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--10-3!../../../../../node_modules/fast-sass-loader/lib/index.js??ref--10-4!./virtual-grid.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("cf47cad0", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-table2/style/virtual-grid.scss
// module id = ks5P
// module chunks = 6